import { PracticeVM } from 'practice/view-models/practice-research';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCellsPracticesAssign: HeadCell<PracticeVM, keyof PracticeVM>[] = [
  {
    id: 'pratice',
    label: 'Pratica',
  },
  {
    id: 'type',
    label: 'Tipo pratica',
  },
  {
    id: 'surname',
    label: 'Cognome',
  },
  {
    id: 'name',
    label: 'Nome',
  },
  {
    id: 'fiscalCode',
    label: 'CF',
  },
  {
    id: 'dateAcquisition',
    label: 'Data acquisizione',
  },
  {
    id: 'dateClose',
    label: 'Data chiusura',
  },
  {
    id: 'dateExchangeState',
    label: 'Data cambio stato',
  },
  {
    id: 'acquisition',
    label: 'Sistema acquisizione',
  },
  {
    id: 'state',
    label: 'Stato',
  },
  {
    id: 'notifications',
    label: 'Notifiche',
  },
];
